import { numbersAndLetter } from '../../validation/expressions';

export function alphaNumericTransform(value: string) {
  const expression = numbersAndLetter;

  if (expression.test(value) === false) {
    return value.substring(0, value.length - 1);
  }

  return value;
}
